/**
 * @flow
 */

import Config from 'config';
import request from './request';

export function updateProfile(locale: string) {
  const options = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      current_user: {
        locale
      }
    })
  };

  return request(`${Config.api.base}/current_user/update_profile`, options)
    .then(res => res.json());
}

export function payInstallment(installmentId: string, token: string) {
  const options = {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      ticket: {
        token
      }
    })
  };

  return request(`${Config.api.base}/tickets/${installmentId}/update_payment_plan_card`, options)
    .then(res => res.json());
}

export function requestTicket(ticketId: string) {
  const options = {
    credentials: 'include'
  };
  return request(`${Config.api.base}/tickets/${ticketId}`, options)
    .then(resp => resp.json());
}

export function updateTicketHF(ticketId: string, ticket: Object, updatedValues: Object) {
  const updatedTicket = Object.assign({}, ticket);
  delete updatedTicket.host_field_ids;
  updatedTicket.host_fields_attributes = updatedValues;

  const data = JSON.stringify({
    ticket: updatedTicket
  });

  const options = {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: data
  };

  return request(`${Config.api.base}/tickets/${ticketId}`, options)
    .then(res => res.json());
}

export function updateCostItemHF(costItemId: string, hostFields: Object, updatedValues: Object) {
  const updatedCostItem = hostFields.cost_item;
  delete updatedCostItem.host_field_ids;
  updatedCostItem.host_fields_attributes = updatedValues;

  const data = JSON.stringify({
    cost_item: updatedCostItem
  });

  const options = {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: data
  };

  return request(`${Config.api.base}/cost_items/${costItemId}`, options)
    .then(res => res.json());
}

export function cancelTransfer(transferId: string) {
  const options = {
    method: 'DELETE',
    credentials: 'include'
  };

  return request(`${Config.api.base}/transfers/${transferId}`, options)
    .then(res => res.json());
}

export function resendTransfer(transferId: string) {
  const options = {
    method: 'PUT',
    credentials: 'include'
  };

  return request(`${Config.api.base}/transfers/${transferId}`, options)
    .then(res => res.json());
}

export function transfer(costItemId: string, ticketRecipient: Object) {
  const data = JSON.stringify({
    email: ticketRecipient.email,
    first_name: ticketRecipient.firstName,
    last_name: ticketRecipient.lastName
  });

  const options = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: data
  };

  return request(`${Config.api.base}/cost_items/${costItemId}/transfer`, options)
    .then(res => res.json());
}

export function sendMessage(message: string, hostId: string, userId: string, link: string) {
  const data = JSON.stringify({
    message: {
      body: message,
      body_html: null,
      conversation_id: null,
      created_at: null,
      recipient_id: hostId,
      sender_id: userId,
      subject: null,
      type: null,
      link
    }
  });

  const options = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: data
  };

  return request(`${Config.api.base}/messages`, options)
    .then(res => res.json());
}

export function cancel(ticketId: string) {
  const options = {
    method: 'DELETE',
    credentials: 'include'
  };

  return request(`${Config.api.base}/tickets/${ticketId}`, options)
    .then(res => res.json());
}

export function generateInvoice(invoiceData: Object, ticketId: string) {
  const data = JSON.stringify({
    invoice: {
      full_name: invoiceData.fullName || null,
      tax_no: invoiceData.taxNumber || null,
      company: invoiceData.company || null,
      address1: invoiceData.address || null,
      address2: null,
      city: invoiceData.city || null,
      country: invoiceData.country || null,
      state: invoiceData.stateProvince || null,
      zip: invoiceData.zipPostal || null,
      ticket_id: ticketId
    }
  });

  const options = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: data
  };

  return request(`${Config.api.base}/invoices`, options)
    .then(res => res.json());
}

export function voidCostItems(ticketId: string, costItemIds: Array<String>) {
  const data = JSON.stringify({
    ticket_id: ticketId,
    cost_item_ids: costItemIds
  });

  const options = {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: data
  };

  return request(`${Config.api.base}/tickets/void_cost_items`, options)
    .then(res => res.json());
}



// WEBPACK FOOTER //
// ./src/lib/api-helper.js